document.addEventListener("DOMContentLoaded", function () {
 // Oculta el banner de cookies de Shopify
 var cookieBanner = document.querySelector("#shopify-pc__banner");
 if (cookieBanner) {
 cookieBanner.style.display = "none";
 cookieBanner.style.visibility = "hidden";
 }
 var consentDone = false;
 function acceptCookiesShopify() {
 if (consentDone) return;
 if (window.Shopify && Shopify.customerPrivacy) {
 Shopify.customerPrivacy.setTrackingConsent({
 analytics: true,
 marketing: true,
 preferences: true,
 sale_of_data: true
 }, function () {
 consentDone = true;
 console.log("[OK] Granular cookies accepted via Shopify API!");
 });
 } else if (window.Shopify && typeof Shopify.loadFeatures === "function") {
 // La API no esta cargada: la cargamos nosotros y volvemos a intentar
 console.log("[...] Cargando consent-tracking-api...");
 Shopify.loadFeatures(
 [{ name: "consent-tracking-api", version: "0.1" }],
 function (error) {
 if (error) {
 console.log("[ERROR] consent-tracking-api", error);
 return;
 }
 acceptCookiesShopify();
 }
 );
 } else {
 // Shopify todavia no ha inicializado: reintento breve
 console.log("[...] Shopify no listo, reintentando...");
 setTimeout(acceptCookiesShopify, 500);
 }
 }
 acceptCookiesShopify();
});